import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { defaultNoteListConfig, kirokuNoteListConfigs, storageChangeKey, timeFormat, unitOfSpan, unitOfTime } from "@app/basic/note-list/config";
import { DisplaySetting, KirokuMenu, MENU_KIDS, MenuParam, RecordList, RecordListConfigPayload, RecordListResponse } from "@app/models/record.model";
import { User } from "@app/models/user.model";
import { OutletRoutePath, RouteCondition, RouteOutlet } from "@app/shared/enum/route";
import { StorageEnum } from "@app/shared/enum/storage";
import { ScrollPositionService } from "@app/shared/scroll.service";
import { AuthSelectors } from "@app/store/auth/auth.selectors";
import { DataSelectors } from "@app/store/data/data.selectors";
import { SetRenderedDataNote, SetUserInGroupList } from "@app/store/data/data.classes";
import { RecordSelectors } from "@app/store/record/record.selectors";
import { CareConneSenderCreateByStudent, ClearRecordList, SetDisplaySetting, SetKirokuSetting } from "@app/store/record/record.classes";
import { ScheduleSelectors } from "@app/store/schedule/schedule.selectors";
import { SettingSelectors } from "@app/store/setting/setting.selectors";
import { SpinnerSelectors } from "@app/store/spinner/spinner.selectors";
import { DestroySpinner, ProcessChange } from "@app/store/spinner/spinner.classes";
import { Select, Store } from "@ngxs/store";
import * as moment from "moment";
import { catchError, filter, finalize, forkJoin, from, fromEvent, Observable, of, skip, Subject, switchMap, takeUntil } from "rxjs";
import { RecordListFunctions } from "../record-list/record-list.functions";
import { RecordListVariables } from "../record-list/record-list.variables";
import { NoteBlobService } from "@app/services/noteblob.service";
import { KirokuSetting } from "@app/models/record-settig.model";
import { RouteControlService } from "@app/services/route-control.service";
import { UserSelectMode } from "@app/services/modal.model";
import { UserService } from "@app/services/dai.service";
import { MenuService } from "@app/services/menu.service";
import { RecordService } from "@app/services/record.service";
import { ApiService, CareConneRelateRes } from "@app/services/api.service";
import { DialogService } from "@app/services/dialog.service";
import { WebviewService } from "@app/services/webview.service";
import { OfficeService } from "@app/services/office.service";
import { LibService } from "@app/services/lib.service";
import { CareConneService } from "@app/services/care-conne/care-conne.service";
import { CareConneSenderByStudent, CareConneSenderByStudentResult, NoteString } from "@app/models/note.model";
import { withTimeout } from "@app/shared/common/utils";
import * as lodash from 'lodash';
import { MESSAGES } from "@app/shared/common/constants";
import { ModalService } from "@app/services/modal.service";

@Component({
    templateUrl: './record-list-navigate.html',
    styleUrls: ['./record-list-navigate.scss']
})
export class RecordListNavigateComponent {

    constructor() {
    }

    screen = MENU_KIDS;

    get currentMenu() {
        return localStorage.getItem('menu') || MENU_KIDS.KIROKU;
    }
}

@Component({
    template: ''
})
export abstract class RecordListBase implements OnInit, OnDestroy, AfterViewInit {
    // add base record list for better structure
    // elements
    @ViewChild('end') endEle: ElementRef | undefined;
    // observables
    // @Select(SpinnerSelectors.progress) progress$!: Observable<number>;
    @Select(RecordSelectors.recordList_Paging) recordList$!: Observable<RecordListResponse>;
    @Select(ScheduleSelectors.fetchHistory) reload$!: Observable<Date>;
    @Select(SpinnerSelectors.isLoading) isLoading$!: Observable<boolean>;
    @Select(DataSelectors.selectedUser) user$!: Observable<User>;
    protected onDestory$!: Subject<void>;
    protected onDestorySpinner$!: Subject<void>;
    protected menuSignature = 'menu';
    // variable
    lazySpinner = false;
    functions!: RecordListFunctions;
    pagingOffset = 1;
    writable!: boolean;
    fromDate?: Date | null = null;
    setting!: MenuParam & DisplaySetting;
    maxPerPage: number = 1;
    currentItemThisPage: number = 0;
    takeRecord: number = 0;
    _daily: RecordList[] = [];
    groupDailys: any[] = [];
    // 
    textWhite: string = "#ffffff";
    hasDateRangeError: boolean = false;
    page = 1;
    // config: KirokuSetting | null = null;
    groupList: any;
    renderData: any[] = [];
    isFetching = false;
    screen = MENU_KIDS;
    stfnm: string = '';
    routeCondition = RouteCondition;
    private forceAbort = false;
    lastNoteValue: string | null = null; // initialize state must be null
    
    isRefresh: boolean = false;
    roomBySudentModal: string | null = null;

    // getter - setter
    get config() {
        return this.store.selectSnapshot(RecordSelectors.kirokuSetting) || this.createDefault();
    }

    get sdate() {
        if (this.config.recently) return '';
        return this.config.sdate || '';
    }

    get edate() {
        if (this.config.recently) return '';
        return this.config.edate || '';
    }

    get screenName() {
        return this.menuConfig.screenName;
    }

    get routeStateCondition() {
        return this.store.selectSnapshot(SettingSelectors.routeCondition);
    }

    get menuConfig() {
        return kirokuNoteListConfigs.find(x => x.type === this.currentMenu) || defaultNoteListConfig;
    }

    get isSingleUser() {
        return !this.menuConfig.isMultipleUser;
    }

    get kidsData() {
        return localStorage.getItem(StorageEnum.CONDITION) || '{}';
    }

    get currentMenu(): string {
        return localStorage.getItem(StorageEnum.MENU) || MENU_KIDS.KIROKU;
    }

    get userList() {
        return this.daiService.userList;
    }

    get profile() {
        return this.store.selectSnapshot(AuthSelectors.profile);
    }

    get isLastPage() {
        return this.lastNoteValue === '';
    }
    get selectedSDate() {
        return moment(this.config?.sdate).isValid() ? moment(this.config?.sdate).toDate() : moment().toDate();
    }
    get selectedEDate() {
        return moment(this.config?.edate).isValid() ? moment(this.config?.edate).toDate() : moment().add(1, 'day').toDate();
    }
    get isCareConneFeat() {
        return this.store.selectSnapshot(SettingSelectors.isCareConneFeature);
    }

    get disabledCareConneSend() {
        return !this.isCareConneFeat || !this.flatRenderData.length || this.isSendCareConnePopupOpening;
    }

    // use for better data change
    get flatRenderData() {
        const flatData = (this.renderData as any[]).flatMap(x => x.notes.flatMap((note: any) => note.data));
        return flatData;
    }

    get pdfRenderDataSubject() {
        return this.careConneService.renderPDFSubject;
    }

    get currentlastNoteValue() {
        return this.lastNoteValue;
    }

    isRequireUserSelect(config: KirokuSetting) {
        const haveDais = config.daicds && config.daicds?.length > 0;
        const isInit = config.isInit
        return !haveDais && this.isSingleUser && isInit;
    }

    get isSendCareConnePopupOpening() {
        return this.roomBySudentModal !== null;
    }

    constructor(
        protected careConneService: CareConneService,
        protected daiService: UserService,
        protected store: Store,
        protected route: ActivatedRoute,
        protected menuService: MenuService,
        protected recordService: RecordService,
        protected apiService: ApiService,
        protected vcRef: ViewContainerRef,
        protected cd: ChangeDetectorRef,
        protected router: Router,
        protected scrollService: ScrollPositionService,
        protected dialog: DialogService,
        protected webviewService: WebviewService,
        protected routeControl: RouteControlService,
        protected officeService: OfficeService,
        protected noteblobService: NoteBlobService,
        protected libService: LibService,
        protected ngZone: NgZone,
        protected modalService: ModalService
        // protected cpuMonitor: CpuMonitorService
    ) {
        const objectcd = this.officeService.officecd;
        this.store.dispatch(new SetUserInGroupList(objectcd));
        this.initConstructor();
        routeControl.removeAllSignature();
    }

    protected initConstructor() {
        this.onDestory$ = new Subject();
        this.onDestorySpinner$ = new Subject();
        this.functions = new RecordListFunctions(new RecordListVariables());
        this.resetScheduleList();
        // scroll reset
        this.scrollService.scrollPosition$.subscribe(x => {
            setTimeout(() => window.scrollTo(0, x), 0, {});
        });
    }

    // protected spinnerInit() {
    //     this.isLoading$.pipe(
    //         takeUntil(this.onDestorySpinner$),
    //         finalize(() => {
    //             const spinnerElement = document.querySelector('app-spinner');
    //             if (spinnerElement) {
    //                 spinnerElement.removeAttribute('style');
    //             }
    //         })
    //     ).subscribe((status) => {
    //         this.lazySpinner = status;
    //         if (status) {
    //             const spinnerElement = document.querySelector('app-spinner');
    //             (spinnerElement as any).style.display = 'none';
    //             this.cd.detectChanges();
    //             return;
    //         }
    //         setTimeout(() => {
    //             if (!this.store.selectSnapshot(SpinnerSelectors.isLoading)) {
    //                 this.cd.detectChanges();
    //             }
    //         }, 300);
    //     });
    // }


    ngAfterViewInit(): void {
        let scrollObserver = this.functions?.variables?.scrollObserver;
        if (this.endEle && !scrollObserver) {
            scrollObserver = new IntersectionObserver(([entry]) => {
                this.renderContents(entry.isIntersecting);
            }, { root: document });
            scrollObserver?.observe(this.endEle.nativeElement);
            this.functions.variables.scrollObserver = scrollObserver;
        }
    }

    ngOnDestroy(): void {
        const scrollObserver = this.functions?.variables?.scrollObserver;
        this.onDestory$.next();
        this.onDestorySpinner$.next();
        this.store.dispatch(new DestroySpinner());
        if (scrollObserver && this.endEle) {
            scrollObserver.unobserve(this.endEle?.nativeElement);
        }
        const spinnerElement = document.querySelector('app-spinner');
        if (spinnerElement) {
            spinnerElement.removeAttribute('style');
        }

        window.removeEventListener('menu-change', this.eventStorageBinding.bind(this));
    }

    ngOnInit(): void {
        const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
        this.isRefresh = navEntries.length > 0 && navEntries[0].type === 'reload';
        this.screenChangeEvent();
        this.storageChangeHandler();
        this.user$.pipe(skip(1), takeUntil(this.onDestory$)).subscribe((res) => {
            if (!res) return;
            this.page = 1;
            this.renderData = [];
            this.store.dispatch(new SetKirokuSetting({ ...this.config, daicds: [res.daicd] }, undefined)).subscribe(() => {
                this.getList();
            });
            this.isFetching = false;
            this.lastNoteValue = null;
        })
    }
    protected abstract rawConfigHandler(): any;
    protected abstract dataConvert(data: any): any;
    protected abstract onUserChange(user: User): any;
    protected abstract renderContents(isIntersecting: boolean): Promise<void>;
    protected openDisplaySetting() {
        return this.router.navigate(['', { outlets: { edit: 'record-display-setting' } }],
            { replaceUrl: true, preserveFragment: true, skipLocationChange: true, queryParamsHandling: 'merge' })
    }
    protected mergeByDate(items: any[]): any[] {
        const map = new Map<string, any>();
        for (const item of items) {
            if (map.has(item.date)) {
                // Merge notes if objcd exists
                const existing = map.get(item.date)!;
                const existingIds = new Set(existing.data.map((d: any) => d.noteid));
                const filtered = item.data.filter((d: any) => !existingIds.has(d.noteid));
                existing.data.push(...filtered);
            } else {
                // Otherwise add new entry (make shallow copy to avoid mutating original)
                map.set(item.date, { ...item, data: [...item.data] });
            }
        }

        return Array.from(map.values());
    }

    protected mergeByObjcd(items: any[]): any[] {
        const map = new Map<string, any>();

        for (const item of items) {
            if (map.has(item.objcd)) {
                // Merge notes if objcd exists
                const currentNotes = map.get(item.objcd)!.notes;
                const mergeNotes = this.mergeByDate([...currentNotes, ...item.notes]);
                map.get(item.objcd)!.notes = mergeNotes;
            } else {
                // Otherwise add new entry (make shallow copy to avoid mutating original)
                map.set(item.objcd, { ...item, notes: [...item.notes] });
            }
        }

        return Array.from(map.values());
    }
    protected getUniqueDatedWithNames(data: any[]): any[] {
        const map = new Map<string, any[]>();
        for (const item of data) {
            const dateKey = moment(item.sdate, timeFormat).format('YYYY-MM-DD');
            if (!map.has(dateKey)) {
                map.set(dateKey, []);
            }
            map.get(dateKey)!.push(item);
        }

        return Array.from(map.entries())
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([date, notes]) => ({
                date, data: notes
            }));
    }
    protected getUniqueObjcdWithTime(data: any[]): { date: string }[] {
        const seen = new Set<string>();
        const result: { date: string }[] = [];
        for (const item of data) {
            const key = moment(item.sdate, timeFormat).format('YYYY-MM-DD');
            if (!seen.has(key)) {
                seen.add(key);
                result.push({ date: moment(item.sdate, timeFormat).format('YYYY-MM-DD') });
            }
        }
        return result;
    }
    protected getUniqueObjcdWithNames(data: any[]): { objcd: string; objnm: string }[] {
        const seen = new Set<string>();
        const result: { objcd: string; objnm: string, ownunitcd: string }[] = [];
        for (const item of data) {
            if (!seen.has(item.objcd)) {
                seen.add(item.objcd);
                result.push({ objcd: item.objcd, objnm: item.objnm, ownunitcd: item.ownunitcd });
            }
        }
        return result;
    }

    protected eventStorageBinding() {
        this.storageChangeHandler();
    }

    protected storageChangeHandler(config?: KirokuSetting) {
        this.dialog.removeAll();
        this.renderData = [];
        this.cd.detectChanges();
        this.initList(config);
    }
    protected async getList() {
        if (this.isLastPage) return;
        if (!this.config) return;
        const { daicds, ttl, sdate, edate, limit, pickupflg, keyword, stfcds, recently, ttlnames, recordType, screen, officeOnly } = this.config;
        let payload: RecordListConfigPayload | null = null;
        payload = {
            daicds, ttl, sdate, edate,
            page: this.page,
            limit,
            pickupflg: pickupflg || false,
            keyword: keyword || [],
            stfcds: stfcds || [],
            screen: screen,
            recently: recently || false,
            recordType: recordType || 0,
            ttlnames: ttlnames || [],
            officeOnly: officeOnly || false,
            lastNoteValue: this.lastNoteValue ?? ''
        }
        this.isFetching = true;
        // this.spinnerInit();
        from(this.apiService.fetchRecordList(payload)).pipe(
            catchError(() => { this.page = -1; return []; }),
            switchMap((data) => {
                this.lastNoteValue = data.lastNoteValue ?? '';
                const notes = data.notes ?? [];
                if (notes.length > 0) {
                    const updatedNotes$ = this.noteblobService.fetchAndMapNoteBlobs(notes);
                    // Wait for all note updates to complete
                    return forkJoin(updatedNotes$);
                }
                return of(data.notes);
            }),
            finalize(() => {
                this.isFetching = false;
                this.onDestorySpinner$.next();
            })
        ).subscribe((data) => {
            this.dataConvert(data);
            this.onDestorySpinner$.next();
        });
    }
    protected getProfile() {
        try {
            const _profileStr = localStorage.getItem('profile');
            if (_profileStr === '' || !_profileStr) return;
            const objProfile = JSON.parse(_profileStr);
            this.stfnm = objProfile["fullName"] || '';
        } catch (error) {
            console.log(error);
        }

    }

    protected selectUser() {
        return this.dialog.select({ multiple: false, mode: UserSelectMode.DAI });
    }


    protected initList(config?: KirokuSetting) {
        this.page = 1;
        this.lastNoteValue = null;
        const _config = config || this.rawConfigHandler();
        if (this.isRequireUserSelect(_config)) {
            this.isFetching = true;
            this.store.dispatch(new SetKirokuSetting({ ..._config }, _config.origin));
            this.router.navigate(['home/list-user'], { replaceUrl: true }).then(() => {
                this.router.navigate(['', { outlets: { [RouteOutlet.EDIT]: OutletRoutePath.USER_SELECT_RECORD } }], { replaceUrl: true });
            });
            return;
        } else {
            this.store.dispatch(new SetKirokuSetting({ ..._config }, _config.origin));
            this.getList();
        }
        this.webviewService.kidsHeaderNameIos(this.menuConfig.screenName, '1');
    }

    public handleOpenDisplaySetting() {
        this.routeControl.addSignature(this.menuSignature).then(() => {
            setTimeout(() => {
                this.openDisplaySetting()
            }, 20)
        });
    }

    public onSDateChange(currentSDate: any) {
        const sDate = moment(currentSDate).startOf('date').toDate();
        if (moment(currentSDate).isAfter(moment(this.selectedEDate))) {
            this.hasDateRangeError = true;
        }
        else {
            this.hasDateRangeError = false;
            this.renderData = [];
            this.store.dispatch(new SetDisplaySetting({ ...this.setting, sdate: sDate }));
        }
        if (!this.config) return;
        const _config = { ...this.config };
        if (!this.hasDateRangeError) {
            _config.sdate = moment(sDate).startOf('date').format(timeFormat);
        } else {
            _config.edate = moment(sDate).endOf('date').format(timeFormat);
        }
        this.store.dispatch(new SetKirokuSetting(_config));
        this.page = 1;
        this.lastNoteValue = null;
        this.getList();
    }

    public onEDateChange(currentEDate: any) {
        const eDate = moment(currentEDate).endOf('date').toDate();
        if (moment(currentEDate).isBefore(moment(this.selectedSDate))) {
            this.hasDateRangeError = true;
        }
        else {
            this.hasDateRangeError = false;
            this.renderData = [];
            this.store.dispatch(new SetDisplaySetting({ ...this.setting, edate: eDate }));
        }
        if (!this.config) return;
        const _config = { ...this.config };
        if (this.hasDateRangeError) {
            _config.sdate = moment(eDate).startOf('date').format("YYYY-MM-DD HH:mm");
        } else {
            _config.edate = moment(eDate).endOf('date').format("YYYY-MM-DD HH:mm");
        }
        this.store.dispatch(new SetKirokuSetting(_config));
        this.page = 1;
        this.lastNoteValue = null;
        this.getList();
    }

    protected screenChangeEvent() {
        // storage event
        fromEvent<StorageEvent>(window, 'storage')
            .pipe(
                filter((x: StorageEvent) => storageChangeKey.some(key => key === x.key)),
                takeUntil(this.onDestory$)
            ).subscribe(() => this.storageChangeHandler());
        window.addEventListener('menu-change', this.eventStorageBinding.bind(this));
        this.reload$.pipe(takeUntil(this.onDestory$), skip(1)).subscribe(() => this.storageChangeHandler(this.config));
    }


    private resetScheduleList() {
        this.store.dispatch(new ClearRecordList());
    }

    protected createDefault() {
        const timeSpan = this.menuConfig.initDaySpan;
        const pickupFlag = this.currentMenu == KirokuMenu.MOUSHIOKURI;
        const defaultConfig = this.defaultKirokuSetting({ pickupFlag, timeSpan, screen: this.currentMenu });
        return defaultConfig;
    }

    protected defaultKirokuSetting = (init: { pickupFlag: boolean, timeSpan: number, screen: string | KirokuMenu }): KirokuSetting => {
        const { timeSpan, pickupFlag, screen } = init;
        const initDate = moment().startOf(unitOfTime);
        let sdate: moment.Moment = initDate.clone();
        let edate: moment.Moment = initDate.clone().endOf(unitOfTime);
        if (timeSpan < 0) {
            edate = initDate.clone().endOf(unitOfTime);
            sdate = initDate.clone().subtract(Math.abs(timeSpan), unitOfSpan).startOf(unitOfTime)
        } else {
            sdate = initDate.clone()
            edate = initDate.clone().add(timeSpan, unitOfSpan).endOf(unitOfTime)
        }
        const payload: KirokuSetting = {
            daicds: [],
            ttl: [],
            sdate: sdate.format(timeFormat),
            edate: edate.format(timeFormat),
            pickupflg: pickupFlag,
            screen,
            isInit: true
        }
        return payload;
    }

    protected generateRoomContent(flatData: any[]): string {
        let sdate = this.config.sdate;
        let edate = this.config.edate;
        let from = moment(sdate, timeFormat).format('MM/DD HH:mm');
        let to = moment(edate, timeFormat).format('MM/DD HH:mm');
        // let isRecordContains = flatData.filter(note => note.dockbn != 1).length > 0;
        // let isChohyoContains = flatData.filter(note => note.dockbn == 1).length > 0;
        // let joinString = [
        //     isRecordContains ? '記録' : '',
        //     isChohyoContains ? '帳票' : '',
        // ].filter(x => x != '').join('・')
        // let message = `${from}~${to}の${joinString}を確認してください。`;
        let message = `${from}~${to}の連絡ノートを確認してください。`;
        return message;

    }

    // public async popupCareConnePicker() {
    //     try {
    //         if (this.disabledCareConneSend) return;
    //         this._manualDisabled = true;
    //         if (!this.flatRenderData.length) return;
    //         let message = this.generateRoomContent(this.flatRenderData);
    //         this.store.dispatch(new CareConneSenderCreate([], message));
    //         let daicds = new Set(this.flatRenderData.map(x => x.objcd)) || [];
    //         let roomData = await this.careConneService.pickRooms([...daicds].length === 1 ? [...daicds][0] : null);
    //         if (!roomData) {
    //             return;
    //         }
    //         this.cd.detectChanges()
    //         await new Promise(resolve => setTimeout(resolve, 600));
    //         await this.collectCareConneData(roomData);
    //     } catch (error) {

    //     } finally {
    //         this._manualDisabled = false;
    //     }
    // }
    
    // public async collectCareConneData(roomInfo: {
    //     roomIds: number[];
    //     message: string;
    // }) {
    //     if (!this.flatRenderData.length) return;
    //     this.webviewService.triggerSpinnerMobile(true);
    //     let alerDestroy$ = new Subject<void>();
    //     try {
    //         // this.cpuMonitor.startMonitoring();
    //         // this.cpuMonitor.cpuAlert
    //         //     .pipe(takeUntil(alerDestroy$))
    //         //     .subscribe(() => {
    //         //         this.forceAbort = true;
    //         //     });
    //         let prepareSendObjs: NoteString[] = [];
    //         let counter = 0;
    //         // jobs = renders + send
    //         let maxJobLength = this.flatRenderData.length + 1;
    //         document.body.classList.add('forced-lock');
    //         this.cd.detectChanges();
    //         await new Promise(resolve => setTimeout(resolve, 100));
    //         await withTimeout((async (timeOut: any) => {
    //             for (let note of this.flatRenderData) {
    //                 if (timeOut.aborted) {
    //                     throw (this.careConneService.defaultExceedError());
    //                 }
    //                 if (this.forceAbort) {
    //                     throw (this.careConneService.defaultMemoryError());
    //                 }
    //                 this.pdfRenderDataSubject.next(undefined);
    //                 this.cd.detectChanges();
    //                 const isChohyo = note.dockbn == 1;
    //                 const { noteid, objcd } = note;
    //                 let formatdata: NoteString = {
    //                     noteid,
    //                     objcd
    //                 }
    //                 // if (isChohyo) {
    //                 //     let id = await this.chohyoSend(note);
    //                 //     formatdata.fileid = id;
    //                 // }
    //                 counter++;
    //                 this.store.dispatch(new ProcessChange((counter / maxJobLength) * 100));
    //                 prepareSendObjs.push(formatdata);

    //             }
    //         }), 3 * 60 * 1000);
    //         let status = await this.careConneService.createCareConneSend(prepareSendObjs,
    //             this.config.sdate, this.config.edate, roomInfo.roomIds,
    //             roomInfo.message, this.screenName);
    //         this.store.dispatch(new ProcessChange(100));
    //         await new Promise(resolve => setTimeout(resolve, 100));
    //         if (!status) {
    //             console.log('status return fail');
    //             throw ('')!
    //         }
    //         this.careConneService.sendSuccessDialog();
    //     } catch (error: any | CareConneRelateRes) {
    //         let msg = error?.statusCode ? error?.message : '';
    //         this.careConneService.sendFailDialog(msg);
    //         this.processRemove();
    //     } finally {
    //         alerDestroy$.next();
    //         // this.cpuMonitor.endMonitoring();
    //         this.forceAbort = false;
    //         this._manualDisabled = false;
    //         this.processRemove();

    //     }
    // }

    protected processRemove() {
        this.store.dispatch(new ProcessChange(100));
        this.pdfRenderDataSubject.next(undefined);
        this.cd.detectChanges();
        document.body.classList.remove('forced-lock');
        this.webviewService.triggerSpinnerMobile(false);
    }

    // protected async chohyoSend(chohyo: Note): Promise<string | undefined> {
    //     let param = {
    //         ttlkbn: chohyo.ttlkbn,
    //         ttlcd: chohyo.ttlcd,
    //         sdate: moment().toDate().toUTCString()
    //     }
    //     let title = await this.apiService.fetchTitleData(param);
    //     if (!title) {
    //         console.log('no title')
    //         throw ({ status: false, message: '' })
    //     }
    //     let observableNote = this.noteblobService.fetchAndMapNoteBlobsByProxy([chohyo]);
    //     let noteFinal = await firstValueFrom(observableNote[0]);
    //     const _renderData = {
    //         noteData: noteFinal,
    //         device: 1,
    //         titleObject: title
    //     };
    //     this.pdfRenderDataSubject.next(_renderData);
    //     this.cd.detectChanges();
    //     let blob = await this.careConneService.pdfGenerator();
    //     if (!blob) {
    //         console.log('Can not generate file');
    //         throw (this.careConneService.defaultError())
    //     }
    //     let id = await this.careConneService.pushIdToS3(blob);
    //     if (!id) {
    //         console.log('Can not get pdf id');
    //         throw ({ status: false, message: '' })
    //     }
    //     return id;
    // }

    // public async popupCareConnePicker() {
    //     try {
    //         if (this.disabledCareConneSend) return;
    //         this._manualDisabled = true;
    //         if (!this.flatRenderData.length) return;
    //         let message = this.generateRoomContent(this.flatRenderData);
    //         this.store.dispatch(new CareConneSenderCreateByStudent([], message));
    //         const groupedByUnit = lodash.groupBy(this.flatRenderData, 'ownunitcd')
    //         this.store.dispatch(new SetRenderedDataNote(groupedByUnit));
    //         let daicds = new Set(this.flatRenderData.map(x => x.objcd)) || [];
    //         let roomData = await this.careConneService.pickRoomsByStudent(Array.from(daicds));
    //         if (!roomData) {
    //             return;
    //         }
    //         console.log("roomData:", roomData);
    //         const sanitizedRoom = roomData.filter((room) => room.daicd);
    //         this.cd.detectChanges()
    //         await new Promise(resolve => setTimeout(resolve, 600));
            
    //         const results = await Promise.all(
    //             sanitizedRoom.map(room =>
    //                 this.collectCareConneData(room)
    //             )
    //         );
    //         const hasFail = results.some(r => !r);
    //         const hasSuccess = results.some(r => r);

    //         if (hasFail) {
    //             this.careConneService.sendFailDialog('Có lỗi xảy ra ở một số phòng');
    //         } else if (hasSuccess) {
    //             this.careConneService.sendSuccessDialog();
    //         }
    //     } catch (error) {

    //     } finally {
    //         this._manualDisabled = false;
    //     }
    // }

    public async popupCareConnePicker() {
        try {
            if (this.disabledCareConneSend) return;

            if (!this.flatRenderData.length) return;

            let message = this.generateRoomContent(this.flatRenderData);

            this.store.dispatch(
                new CareConneSenderCreateByStudent([], message)
            );

            const groupedByUnit = lodash.groupBy(this.flatRenderData, 'ownunitcd');
            this.store.dispatch(new SetRenderedDataNote(groupedByUnit));

            this.roomBySudentModal = 'rooms-by-student-' + Date.now();
            this.modalService.createModal(this.roomBySudentModal)
                .subscribe((result) => {
                    this.roomBySudentModal = result.isOpening ? this.roomBySudentModal : null;
                });

            let daicds = new Set(this.flatRenderData.map(x => `${x.ownunitcd}#${x.objcd}`)) || [];
            let roomData = await this.careConneService.pickRoomsByStudent(Array.from(daicds), this.roomBySudentModal);

            if (!roomData) return;

            const sanitizedRoom = roomData.filter(room => room.daicd);

            this.cd.detectChanges();
            await new Promise(resolve => setTimeout(resolve, 600));

            this.webviewService.triggerSpinnerMobile(true);

            const results = await Promise.all(
                sanitizedRoom.map(room => this.collectCareConneData(room))
            );
            const successCount = results.filter(r => r.status).length;
            const failCount = results.length - successCount;

            if (failCount > 0) {
                const errorMsg = this.buildErrorContent(successCount, failCount, results);
                this.careConneService.sendFailDialog(errorMsg);
            } else {
                this.careConneService.sendSuccessDialog();
            }

        } catch (error: any | CareConneRelateRes) {
            let msg = error?.statusCode ? error?.message : '';
            this.careConneService.sendFailDialog(msg);
        } finally {
            this.webviewService.triggerSpinnerMobile(false);
        }
    }

    // public async collectCareConneData(roomInfo: CareConneSenderByStudent) {
    //     if (!this.flatRenderData.length) return;
    //     if (!roomInfo.daicd) return;
    //     this.webviewService.triggerSpinnerMobile(true);
    //     let alerDestroy$ = new Subject<void>();
    //     try {
    //         // this.cpuMonitor.startMonitoring();
    //         // this.cpuMonitor.cpuAlert
    //         //     .pipe(takeUntil(alerDestroy$))
    //         //     .subscribe(() => {
    //         //         this.forceAbort = true;
    //         //     });
    //         let prepareSendObjs: NoteString[] = [];
    //         let counter = 0;
    //         // jobs = renders + send
    //         const careConneRoomAllList = this.store.selectSnapshot(DataState.careConneRoomAllList);
    //         const notes = careConneRoomAllList[roomInfo.daicd]?.notes ?? [];
    //         let maxJobLength = notes?.length + 1;
    //         document.body.classList.add('forced-lock');
    //         this.cd.detectChanges();
    //         await new Promise(resolve => setTimeout(resolve, 100));
    //         await withTimeout((async (timeOut: any) => {
    //             for (let note of notes) {
    //                 if (timeOut.aborted) {
    //                     throw (this.careConneService.defaultExceedError());
    //                 }
    //                 if (this.forceAbort) {
    //                     throw (this.careConneService.defaultMemoryError());
    //                 }
    //                 this.pdfRenderDataSubject.next(undefined);
    //                 this.cd.detectChanges();
    //                 // const isChohyo = note.dockbn == 1;
    //                 const { noteid, objcd } = note;
    //                 let formatdata: NoteString = {
    //                     noteid,
    //                     objcd
    //                 }
    //                 // if (isChohyo) {
    //                 //     let id = await this.chohyoSend(note);
    //                 //     formatdata.fileid = id;
    //                 // }
    //                 counter++;
    //                 this.store.dispatch(new ProcessChange((counter / maxJobLength) * 100));
    //                 prepareSendObjs.push(formatdata);

    //             }
    //         }), 3 * 60 * 1000);
    //         let status = await this.careConneService.createCareConneSend(prepareSendObjs,
    //             this.config.sdate, this.config.edate, roomInfo.roomIds,
    //             roomInfo.message, this.screenName);
    //         this.store.dispatch(new ProcessChange(100));
    //         await new Promise(resolve => setTimeout(resolve, 100));
    //         if (!status) {
    //             console.log('status return fail');
    //             throw ('')!
    //         }
    //         // this.careConneService.sendSuccessDialog();
    //     } catch (error: any | CareConneRelateRes) {
    //         let msg = error?.statusCode ? error?.message : '';
    //         // this.careConneService.sendFailDialog(msg);
    //         this.processRemove();
    //     } finally {
    //         alerDestroy$.next();
    //         // this.cpuMonitor.endMonitoring();
    //         this.forceAbort = false;
    //         this._manualDisabled = false;
    //         this.processRemove();
    //     }
    // }

    public async collectCareConneData(
        roomInfo: CareConneSenderByStudent
    ): Promise<CareConneSenderByStudentResult> {

        if (!this.flatRenderData.length) return { daicd: roomInfo.daicd, status: false, message: MESSAGES.COMMON.NOTE_LIST_LENGTH_ZERO };
        if (!roomInfo.daicd) return { daicd: roomInfo.daicd, status: false, message: MESSAGES.COMMON.MISSING_DAICD };

        const daicd = roomInfo.daicd;
        let alerDestroy$ = new Subject<void>();

        try {
            let prepareSendObjs: NoteString[] = [];
            let counter = 0;

            const careConneRoomAllList = this.store.selectSnapshot(
                DataSelectors.careConneRoomAllList
            );

            const notes = this.dedupeNotes(careConneRoomAllList[daicd].roomDataByUnit.flatMap((item) => item.notes)) ?? [];
            let maxJobLength = notes.length + 1;

            document.body.classList.add('forced-lock');
            this.cd.detectChanges();

            await new Promise(resolve => setTimeout(resolve, 100));

            await withTimeout((async (timeOut: any) => {

                for (let note of notes) {

                    if (timeOut.aborted) {
                        throw this.careConneService.defaultExceedError();
                    }

                    if (this.forceAbort) {
                        throw this.careConneService.defaultMemoryError();
                    }

                    this.pdfRenderDataSubject.next(undefined);
                    this.cd.detectChanges();

                    const { noteid, objcd } = note;

                    let formatdata: NoteString = {
                        noteid,
                        objcd
                    };

                    counter++;
                    this.store.dispatch(
                        new ProcessChange((counter / maxJobLength) * 100)
                    );

                    prepareSendObjs.push(formatdata);
                }

            }), 3 * 60 * 1000);

            let daiName = careConneRoomAllList[daicd]?.name;
            let customMessage = roomInfo.message.replace('の連絡ノートを確認してください。', `の${daiName}の連絡ノートを確認してください。`);
            let res = await this.careConneService.createCareConneSend(
                prepareSendObjs,
                this.config.sdate,
                this.config.edate,
                roomInfo.roomIds,
                customMessage,
                this.screenName
            );

            this.store.dispatch(new ProcessChange(100));
            await new Promise(resolve => setTimeout(resolve, 100));
            if (!res.status) {
                return { daicd, status: false, message: res.message };
            }

            return { daicd, status: true };

        } catch (error: any | CareConneRelateRes) {
            let msg = error?.statusCode ? error?.message : '';
            console.error('Send fail:', error);
            return { daicd, status: false, message: msg };

        } finally {
            alerDestroy$.next();
            this.forceAbort = false;
            this.processRemove();
        }
    }

    buildErrorContent(successCount: number, failCount: number, results: CareConneSenderByStudentResult[]) {
        let errorMsg = `<div>成功: ${successCount}, 失敗: ${failCount}`;
        const careConneRoomAllList = this.store.selectSnapshot(
            DataSelectors.careConneRoomAllList
        );
        const failedResults = results.filter(r => !r.status);

        errorMsg += `<li style='max-height: 10rem;overflow: auto;font-weigt: bold'>`;
        for (let failedResult of failedResults) {
            const  daicd = failedResult.daicd!; // daicd at here must be have
            const studentName = careConneRoomAllList[daicd]?.name;
            errorMsg += `<ul style='max-height: 10rem;overflow: auto;'>【${studentName}】: ${failedResult.message}</ul>`;
        }
        errorMsg += '</li>';
        errorMsg += "</div>";
        return errorMsg;
    }

    private dedupeNotes(notes: any[]) {
        const map = new Map();
        notes.forEach((n) => {
            map.set(`${n.noteid}_${n.ownunitcd}`, n);
        });
        return Array.from(map.values());
    }
}